'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _grid = require('@rebass/grid');

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Group = exports.Group = (0, _components2["default"])({
  extend: _grid.Flex
}, function (props) {
  var radius = (0, _styledSystem.themeGet)('radii.2', 4)(props) + 'px';
  return {
    '& > *': {
      borderRadius: 0
    },
    '& > *:first-child': {
      borderRadius: radius + ' 0 0 ' + radius
    },
    '& > *:last-child': {
      borderRadius: '0 ' + radius + ' ' + radius + ' 0'
    }
  };
});
Group.displayName = 'Group';
exports["default"] = Group;